/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const CREATE_CALL_LOG_URL = `${API_URL}/callLogger`;
export const GET_CALL_LOGS_URL = `${API_URL}/callLogger/searchLogger?page=`;
export const GET_SUPPORT_CALLS = `${API_URL}/supportCall/getCount`;
export const GET_SUPPORT_CALLS_COUNT = `${API_URL}/supportCall/graphCount`;
export const CREATE_SUPPORT_CALLS = `${API_URL}/supportCall`;
export const UPDATE_SUPPORT_CALLS = `${API_URL}/supportCall/plusOne`;
